import { render, staticRenderFns } from "./IconTile.vue?vue&type=template&id=52fc1e3b&scoped=true&"
import script from "./IconTile.vue?vue&type=script&lang=js&"
export * from "./IconTile.vue?vue&type=script&lang=js&"
import style0 from "./IconTile.vue?vue&type=style&index=0&id=52fc1e3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc1e3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
